import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_SEND, URL_CLOUD } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import clsx from 'clsx';

import styles from './Banners.module.css';

const HalloweenCampaignBanner = (props) => {
    const { bannerSun25Title, bannerSun25Text } = usePageMessages();
    const [bannerShow, setBannerShow] = useState(false);

    const onClose = (e) => {
        e.stopPropagation();
        localStorage.setItem('bannerHalloween25Show', 'false');
        setBannerShow(false);
    };

    useEffect(() => {
        let bannerHalloween25Show = localStorage.getItem('bannerHalloween25Show');
        if ((bannerHalloween25Show && bannerHalloween25Show !== 'false') || !bannerHalloween25Show) {
            setBannerShow(true);
        }
    }, [bannerShow]);

    const containerClass = clsx(styles.bannerContainer, styles.contentAlignMiddle, styles.halloweenBanner);

    return (
        bannerShow && (
            <a
                className={containerClass}
                onClick={async () => {
                    props.toggleSpinner(true);
                    window.location.href = AUTH_SEND;
                }}
            >
                <span className={styles.bannerCloseButton}>
                    <DiskButton size="small" iconName="cross" iconColor="white_base" type="button" variant="glass" onClick={onClose} />
                </span>
                <div className={styles.bannerTextContainer}>
                    <Text variant="div" color="white_base" indent="8px" size="main">
                        {bannerSun25Title}
                    </Text>
                    <div className={styles.bannerSubtitle}>
                        <Text variant="div" color="white_base" size="secondary" indent="16px">
                            {bannerSun25Text}
                        </Text>
                    </div>
                </div>
                <img className={styles.bannerImage} src={`${URL_CLOUD}/halloween/halloween-cat.webp`} alt="Halloween Campaign" />
            </a>
        )
    );
};
export default connect(null, { toggleSpinner })(HalloweenCampaignBanner);
